import React from "react"
import { Label } from "@/components/shadcn/ui/label"
import { RadioGroup, RadioGroupItem } from "@/components/shadcn/ui/radio-group"
import { BooleanField as BooleanFieldType } from "@/models/new/forms.types"
import { ResponseValue, BooleanResponse } from "@/models/new/formResponse.types"

interface Props {
  field: BooleanFieldType
  value?: ResponseValue
  onChange: (fieldId: string, value: ResponseValue) => void
}

const BooleanField = (props: Props) => {
  const { field, value, onChange } = props

  const currentValue = value?.type === "boolean" ? (value as BooleanResponse).value : undefined

  const handleChange = (nextValue: string) => {
    onChange(field.id, {
      fieldName: field.name,
      type: "boolean",
      value: nextValue,
    })
  }

  return (
    <React.Fragment>
      <div className="w-1/2 p-4">
        <div>
          <Label>{field.label}</Label>
          <RadioGroup
            value={currentValue}
            onValueChange={handleChange}
            className="flex flex-row flex-wrap items-center gap-6 mt-1"
          >
            {field.options.map((option) => (
              <div key={option.value} className="flex min-w-0 items-center gap-2">
                <RadioGroupItem value={option.value} id={`${field.id}-${option.value}`} />
                <Label htmlFor={`${field.id}-${option.value}`} className="font-normal">
                  {option.label}
                </Label>
              </div>
            ))}
          </RadioGroup>
        </div>
      </div>
    </React.Fragment>
  )
}

export default BooleanField
